
const digest = 'c46b37889ab95a219890198996650f97f225e0398d971a4e1fdd65e3992b263c';
const classes = {"wrapper":"_wrapper_1fsuh_1","title":"_title_1fsuh_8","grey":"_grey_1fsuh_24","green":"_green_1fsuh_30","red":"_red_1fsuh_36","orange":"_orange_1fsuh_42","pickerButton":"_pickerButton_1fsuh_49","text":"_text_1fsuh_69"};
const css = `._wrapper_1fsuh_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  padding: 4px 24px 4px 8px;
  border-radius: 6px;
  cursor: pointer;
}
._wrapper_1fsuh_1 ._title_1fsuh_8 {
  color: #000000;
  font-weight: 500;
  position: relative;
  width: 100%;
}
._wrapper_1fsuh_1 ._title_1fsuh_8:after {
  content: "";
  width: 12.5px;
  height: 100%;
  background-image: url("/dist/icons/react/chevron-down-white.svg");
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  right: -15px;
}
._wrapper_1fsuh_1._grey_1fsuh_24 {
  background-color: #cccccc;
}
._wrapper_1fsuh_1._grey_1fsuh_24 ._title_1fsuh_8 {
  color: #000000;
}
._wrapper_1fsuh_1._green_1fsuh_30 {
  background-color: #619612;
}
._wrapper_1fsuh_1._green_1fsuh_30 ._title_1fsuh_8 {
  color: #ffffff;
}
._wrapper_1fsuh_1._red_1fsuh_36 {
  background-color: #d81616;
}
._wrapper_1fsuh_1._red_1fsuh_36 ._title_1fsuh_8 {
  color: #ffffff;
}
._wrapper_1fsuh_1._orange_1fsuh_42 {
  background-color: #f28a11;
}
._wrapper_1fsuh_1._orange_1fsuh_42 ._title_1fsuh_8 {
  color: #ffffff;
}

._pickerButton_1fsuh_49 {
  font-family: Rubik, "sans-serif";
  display: flex;
  padding: 4px 12px 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  justify-content: center;
}
._pickerButton_1fsuh_49._grey_1fsuh_24 {
  background-color: #cccccc;
}
._pickerButton_1fsuh_49._grey_1fsuh_24 ._title_1fsuh_8 {
  color: #000000;
}
._pickerButton_1fsuh_49._green_1fsuh_30 {
  background-color: #619612;
}
._pickerButton_1fsuh_49._green_1fsuh_30 ._text_1fsuh_69 {
  color: #ffffff;
}
._pickerButton_1fsuh_49._red_1fsuh_36 {
  background-color: #d81616;
}
._pickerButton_1fsuh_49._red_1fsuh_36 ._text_1fsuh_69 {
  color: #ffffff;
}
._pickerButton_1fsuh_49._orange_1fsuh_42 {
  background-color: #f28a11;
}
._pickerButton_1fsuh_49._orange_1fsuh_42 ._text_1fsuh_69 {
  color: #ffffff;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  